export interface CognitoConfig {
  userPoolId: string;
  clientId: string;
  domain: string;
  region: string;
  redirectUri: string;
}

export const cognitoConfig: CognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
  redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || 'http://localhost:5173/admin/callback',
};
